


import BreakpointService from '@/shared/services/breakpoint-service';
import {defineComponent, onMounted} from "@vue/composition-api";
import {useGetters, useMutations, useState} from "vuex-composition-helpers";
import NavigationWidgetAnimationService from './services/navigation-widget-animation-service';
import INavigationItem from "@/apps/NavigationWidget/model/navigation-item";


export default defineComponent({
    name: "NavigationWidget",
    props: {
        labels: {type: Object, required: true},
        json: {type: Object, required: true},
        eventListener: {type: String, required: true},
    },
    methods: {
        closeMenu() {
            NavigationWidgetAnimationService.closeMenu();
        },
        goBackToTransitions(rootItem: any) {
            NavigationWidgetAnimationService.goBackToTransitions(rootItem);
        },
        backToHomeTransitions() {
            NavigationWidgetAnimationService.backToHomeTransitions();
        },
        navFirstTransitions(item: INavigationItem) {
            NavigationWidgetAnimationService.navFirstTransitions(item);
        },
        navSecondTransitions(item: INavigationItem) {
            NavigationWidgetAnimationService.navSecondTransitions(item);
        }
    },
    setup: (props) => {
        const {setLabels, setCurrentBreakpoint} = useMutations(['setLabels', 'setCurrentBreakpoint'])
        const {menuOpen, storedTree} = useState(['menuOpen', 'storedTree'])
        const {
            breadCrumb,
            renderGoBackTo,
            checkIfActive,
            firstLevel,
            rootItem
        } = useGetters(['breadCrumb', 'renderGoBackTo', 'checkIfActive', 'firstLevel', 'rootItem'])

        setLabels(props.labels);

        onMounted(() => {
            setCurrentBreakpoint(BreakpointService.currentBreakpoint);

            window.addEventListener('resize', () => {
                setCurrentBreakpoint(BreakpointService.currentBreakpoint);
            });

            NavigationWidgetAnimationService.init(props.json);

            document.querySelectorAll(props.eventListener).forEach(el => {
                el.addEventListener('click', () => {
                    NavigationWidgetAnimationService.openMenu();
                });
            });
        })

        return {
            NavigationWidgetAnimationService,
            menuOpen,
            rootItem,
            storedTree,
            breadCrumb,
            renderGoBackTo,
            checkIfActive,
            firstLevel
        }
    }
})
